<template>
  <div class="mainbar">
    <!-- Page Header -->
    <div class="page-header">
      <div class="page-title-wrap">
        <div v-if="selected" class="dept-chip" style="background: var(--primary-glow); color: var(--primary);">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
          </svg>
        </div>
        <div class="title-center">
          <h1 v-if="selected">{{ selected }}</h1>
          <h1 v-else>Sélectionnez un poste</h1>
          <p class="page-subtitle" v-if="selected">{{ databackup.length }} employé{{ databackup.length !== 1 ? 's' : '' }}</p>
        </div>
      </div>
      <div v-if="selected && (privilage() == 'admin')" class="header-actions-inline">
        <button v-if="!showForm" @click="showForm = true" class="btn btn-primary">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Ajouter employé
        </button>
      </div>
    </div>

    <!-- Create Modal -->
    <AppCreateStaff v-if="showForm" :locked-post="selected" @created="handleStaffCreated" @cancel="showForm = false" />

    <!-- Toolbar -->
    <div v-if="selected && Array.isArray(databackup) && databackup.length > 0" class="toolbar">
      <div class="search-wrap">
        <svg class="search-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input v-model="searchQuery" type="text" placeholder="Rechercher un employé..." @input="searchUsers"
          class="search-input" />
      </div>

      <!-- Bulk Actions -->
      <div v-if="selectedStaffs.length > 0" class="bulk-bar">
        <div class="bulk-left">
          <label class="checkbox-wrap">
            <input type="checkbox" :checked="allSelected" @change="toggleSelectAll" />
            <span class="checkmark"></span>
          </label>
          <span class="bulk-count">{{ selectedStaffs.length }} sélectionné(s)</span>
        </div>
        <div class="bulk-controls">
          <div class="bulk-group">
            <span class="bulk-label">Entrée</span>
            <input type="datetime-local" v-model="masspointageIn" class="form-input datetime-input" />
            <button class="btn btn-success btn-sm" @click="masspointage(selectedStaffs, 'in')">Valider</button>
          </div>
          <div class="bulk-group">
            <span class="bulk-label">Sortie</span>
            <input type="datetime-local" v-model="masspointageOut" class="form-input datetime-input" />
            <button class="btn btn-info btn-sm" @click="masspointage(selectedStaffs, 'out')">Valider</button>
          </div>
        </div>
      </div>
    </div>

    <!-- States -->
    <div v-if="loading" class="state-view">
      <div class="spinner-ring"></div>
      <p>Chargement des employés...</p>
    </div>
    <div v-else-if="error" class="state-view state-error">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <p>{{ error }}</p>
    </div>
    <div v-else-if="!selected" class="state-view">
      <div class="state-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
        </svg>
      </div>
      <p>Sélectionnez un poste pour voir les employés</p>
    </div>

    <!-- No search results -->
    <div v-else-if="selected && Array.isArray(databackup) && databackup.length > 0 && data.length == 0" class="state-view">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 48px; height: 48px; opacity: 0.5;">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <p>Aucun résultat pour "{{ searchQuery }}"</p>
      <button class="btn btn-secondary" @click="searchQuery = ''; searchUsers()">Effacer la recherche</button>
    </div>

    <!-- Staff Grid -->
    <div v-else-if="Array.isArray(data) && data.length > 0" class="staff-grid">
      <div v-for="staff in data" :key="staff.Id" class="staff-card" :class="{ 'selected-card': isSelected(staff), 'stopped-card': staff.Is_stopped === 1 }">
        <!-- Card Top -->
        <div class="card-top">
          <!-- <label class="checkbox-wrap card-check">
            <input type="checkbox" :checked="isSelected(staff)" @change="toggleSelection(staff)" @click.stop />
            <span class="checkmark"></span>
          </label> -->
          <img :src="staff.Pic ? staff.Pic : '/pointage/profile/profile.jpg'" :alt="staff.First_name" class="staff-avatar"
            @click="handleItemClick(staff)" />
          <div class="staff-status-dot" :class="{ 'status-stopped-dot': staff.Is_stopped === 1 }"></div>
        </div>

        <!-- Card Info -->
        <div class="card-info" @click="handleItemClick(staff)">
          <h3>{{ staff.First_name }} {{ staff.Last_name }}</h3>
          <span class="staff-post-badge">{{ staff.Post_name }}</span>
          <span v-if="staff.Is_stopped === 1" class="stopped-badge">Arrêté</span>
        </div>

        <!-- Card Actions -->
        <div class="card-footer">
          <a :href="'tel:' + staff.Phone" class="btn-phone" @click.stop>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path
                d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
            </svg>
            Appeler
          </a>

          <button class="toggle-more-btn" @click.stop="openActions(staff)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="1" />
              <circle cx="19" cy="12" r="1" />
              <circle cx="5" cy="12" r="1" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Load more button -->
      <div v-if="hasMore && data.length > 0" style="display: flex; justify-content: center; padding: 20px;">
        <button @click="loadMore" :disabled="loading" class="btn btn-secondary">
          <span v-if="loading">Chargement...</span>
          <span v-else>Charger plus ({{ data.length }}/{{ totalCount }})</span>
        </button>
      </div>
      <div v-else-if="data.length > 0" style="text-align: center; padding: 20px; color: var(--gray-500); font-size: 14px;">
        Tous les employés sont affichés ({{ totalCount }})
      </div>
    </div>

    <div v-else-if="selected" class="state-view">
      <div class="state-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>
      <p>Aucun employé trouvé</p>
    </div>

    <!-- Action Modal -->
    <transition name="fade">
      <div v-if="activeActionStaff" class="action-modal-overlay" @click="closeActions"></div>
    </transition>
    <transition name="fade">
      <div v-if="activeActionStaff" class="action-modal">
        <div class="action-modal-head">
          <div>
            <p class="action-modal-kicker">Actions employé</p>
            <h2>{{ activeActionStaff.First_name }} {{ activeActionStaff.Last_name }}</h2>
            <span class="staff-post-badge">{{ activeActionStaff.Post_name }}</span>
          </div>
          <button class="close-btn" @click="closeActions">✕</button>
        </div>

        <div class="action-row action-modal-grid">
          <div class="action-item action-in">
            <label class="action-label">
              <span class="action-dot dot-green"></span>Entrée
            </label>
            <input type="datetime-local" v-model="pointageIn" class="form-input datetime-input" />
            <button class="btn btn-success btn-sm" :disabled="activeActionStaff.Is_stopped === 1" @click="pointage(activeActionStaff.Id, 'in')">Entrée</button>
          </div>
          <div class="action-item action-out">
            <label class="action-label">
              <span class="action-dot dot-blue"></span>Sortie
            </label>
            <input type="datetime-local" v-model="pointageOut" class="form-input datetime-input" />
            <button class="btn btn-info btn-sm" :disabled="activeActionStaff.Is_stopped === 1" @click="pointage(activeActionStaff.Id, 'out')">Sortie</button>
          </div>
          <template v-if="privilage() == 'admin'">
            <div class="action-item action-avance">
              <label class="action-label">
                <span class="action-dot dot-amber"></span>Avance
              </label>
              <input type="datetime-local" :value="currentDateTime" class="form-input datetime-input" readonly />
              <input type="number" v-model="avance" placeholder="Montant DH" class="form-input" />
              <button class="btn btn-warning btn-sm" @click="addAvance(activeActionStaff.Id)">Ajouter</button>
            </div>
            <div class="action-item action-prime">
              <label class="action-label">
                <span class="action-dot dot-orange"></span>Prime
              </label>
              <input type="datetime-local" :value="currentDateTime" class="form-input datetime-input" readonly />
              <input type="number" v-model="prime" placeholder="Montant DH" class="form-input" />
              <button class="btn btn-prime btn-sm" @click="addPrime(activeActionStaff.Id)">Ajouter</button>
            </div>
            <div class="action-item action-retenue">
              <label class="action-label">
                <span class="action-dot dot-red"></span>Retenue
              </label>
              <input type="datetime-local" :value="currentDateTime" class="form-input datetime-input" readonly />
              <input type="number" v-model="retenue" placeholder="Montant DH" class="form-input" />
              <input type="text" v-model="retenueReason" placeholder="Motif" class="form-input" />
              <button class="btn btn-danger btn-sm" @click="addRetenue(activeActionStaff.Id)">Ajouter</button>
            </div>
            <div class="action-item action-remarque">
              <label class="action-label">
                <span class="action-dot dot-purple"></span>Remarque
              </label>
              <input type="text" v-model="remarque" placeholder="Entrez une remarque..." class="form-input" />
              <button class="btn btn-note btn-sm" @click="addRemarque(activeActionStaff.Id)">Ajouter</button>
            </div>
            <div class="action-item action-cancel-open">
              <label class="action-label">
                <span class="action-dot dot-gray"></span>Correction pointage
              </label>
              <p class="action-help">Annuler uniquement l'entrée ouverte si elle a été faite par erreur.</p>
              <button class="btn btn-secondary btn-sm" @click="cancelOpenPointage(activeActionStaff)">
                Annuler l'entrée en cours
              </button>
            </div>
          </template>
        </div>
      </div>
    </transition>

    <!-- Overlay -->
    <transition name="fade">
      <div v-if="selectedStaff" class="detail-overlay" @click="selectedStaff = null"></div>
    </transition>

    <!-- Detail Panel -->
    <transition name="slide-right">
      <div v-if="selectedStaff" class="detail-panel">
        <div class="detail-panel-inner">
          <button class="close-btn detail-close" @click="selectedStaff = null">✕</button>

          <!-- Staff Photo & Name -->
          <div class="detail-hero">
            <img :src="selectedStaff.Pic ? selectedStaff.Pic : '/pointage/profile/profile.jpg'" :alt="selectedStaff.First_name"
              class="detail-avatar" />
            <h2>{{ selectedStaff.First_name }} {{ selectedStaff.Last_name }}</h2>
            <span class="staff-post-badge">{{ selectedStaff.Post_name }}</span>
          </div>

          <!-- Info List -->
          <div class="detail-info">
            <div class="info-item" v-if="selectedStaff.Id">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <circle cx="8" cy="10" r="2" />
                  <line x1="14" y1="8" x2="20" y2="8" />
                  <line x1="14" y1="12" x2="20" y2="12" />
                  <line x1="14" y1="16" x2="20" y2="16" />
                </svg>
              </div>
              <div>
                <div class="info-label">ID</div>
                <div class="info-value">{{ selectedStaff.Id }}</div>
              </div>
            </div>
            <div class="info-item" v-if="selectedStaff.Email">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <polyline points="22,4 12,13 2,4" />
                </svg>
              </div>
              <div>
                <div class="info-label">CIN / Email</div>
                <div class="info-value">{{ selectedStaff.Email }}</div>
              </div>
            </div>
            <div class="info-item" v-if="selectedStaff.Phone">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path
                    d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                </svg>
              </div>
              <div>
                <div class="info-label">Téléphone</div>
                <div class="info-value">{{ selectedStaff.Phone }}</div>
              </div>
            </div>
            <div class="info-item" v-if="selectedStaff.Adress">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div>
                <div class="info-label">Adresse</div>
                <div class="info-value">{{ selectedStaff.Adress }}</div>
              </div>
            </div>
            <div class="info-item" v-if="selectedStaff.Salary">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="12" y1="1" x2="12" y2="23" />
                  <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
                </svg>
              </div>
              <div>
                <div class="info-label">Salaire</div>
                <div class="info-value salary-value">{{ selectedStaff.Salary }} MAD</div>
              </div>
            </div>
            <div class="info-item" v-if="selectedStaff.Created_at">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </div>
              <div>
                <div class="info-label">Créé le</div>
                <div class="info-value">{{ convertclock(selectedStaff.Created_at) }}</div>
              </div>
            </div>
            <div class="info-item" v-if="selectedStaff.Resignation_date">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                  <line x1="9" y1="14" x2="15" y2="18" />
                  <line x1="15" y1="14" x2="9" y2="18" />
                </svg>
              </div>
              <div>
                <div class="info-label">Date de démission</div>
                <div class="info-value resignation-value">{{ formatDate(selectedStaff.Resignation_date) }}</div>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon status-info-icon" :class="{ 'status-info-stopped': selectedStaff.Is_stopped === 1 }">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <path v-if="selectedStaff.Is_stopped === 1" d="M8 12h8" />
                  <path v-else d="M8 12l3 3 5-6" />
                </svg>
              </div>
              <div>
                <div class="info-label">Statut</div>
                <div class="info-value" :class="{ 'resignation-value': selectedStaff.Is_stopped === 1 }">
                  {{ selectedStaff.Is_stopped === 1 ? 'Arrêté' : 'Actif' }}
                </div>
              </div>
            </div>
          </div>

          <!-- Admin Actions -->
          <div v-if="privilage() == 'admin'" class="detail-actions">
            <button class="btn btn-primary btn-block" @click="showEditForm = !showEditForm">

              {{ showEditForm ? 'Fermer' : 'Modifier' }}
            </button>
            <button class="btn btn-secondary btn-block" @click="openDossier(selectedStaff.Id)">
              Dossier RH
            </button>
            <button class="btn btn-danger btn-block" @click="deletStaf(selectedStaff)">
              Supprimer
            </button>
          </div>

          <!-- Edit Form -->
          <AppUpdateStaff v-if="showEditForm" :staffData="selectedStaff" @updated="handleStaffCreated"
            @cancel="showEditForm = false" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AppCreateStaff from './AppCreateStaff.vue';
import AppUpdateStaff from './AppUpdateStaff.vue';

export default {
  inject: ['privilage'],
  name: 'AppMainBar',
  components: { AppCreateStaff, AppUpdateStaff },
  props: { selected: { type: String, default: null } },
  data() {
    return {
      selectedStaffs: [], searchQuery: null,
      absent: null, avance: null, prime: null, retenue: null, retenueReason: '', remarque: null,
      pointageIn: null, pointageOut: null,
      masspointageIn: null, masspointageOut: null,
      currentDateTime: '',
      currentDateTimeTimer: null,
      showEditForm: false, showForm: false,
      data: [], databackup: [], loading: false, error: null, selectedStaff: null, activeActionStaff: null,
      currentPage: 1,
      limit: 50,
      totalCount: 0,
      hasMore: true,
      lastPost: null,
    };
  },
  watch: {
    selected(newVal) {
      if (newVal) { this.selectedStaffs = []; this.showForm = false; this.fetchData(newVal); }
    },
  },
  mounted() {
    this.selectedStaffs = [];
    this.refreshCurrentDateTime();
    this.currentDateTimeTimer = setInterval(this.refreshCurrentDateTime, 30000);
    this.fetchData(this.selected);
  },
  beforeUnmount() {
    if (this.currentDateTimeTimer) {
      clearInterval(this.currentDateTimeTimer);
    }
  },
  computed: {
    allSelected() { return this.selectedStaffs.length === this.data.length && this.data.length > 0; },
  },
  methods: {
    isSelected(staff) { return this.selectedStaffs.some(item => item.Id === staff.Id); },
    toggleSelection(staff) {
      const idx = this.selectedStaffs.findIndex(item => item.Id === staff.Id);
      if (idx === -1) this.selectedStaffs.push(staff);
      else this.selectedStaffs.splice(idx, 1);
    },
    toggleSelectAll(event) {
      this.selectedStaffs = event.target.checked ? [...this.data] : [];
    },
    searchUsers() {
      if (!Array.isArray(this.databackup)) { this.data = []; return; }
      const query = String(this.searchQuery || '').toLowerCase();
      this.data = this.databackup.filter(s =>
        String(s.First_name || '').toLowerCase().includes(query) ||
        String(s.Last_name || '').toLowerCase().includes(query)
      );
    },
    formatForServer(datetimeLocal) {
      if (!datetimeLocal) {
        const now = new Date();
        const pad = n => String(n).padStart(2, '0');
        return `${now.getFullYear()}/${pad(now.getMonth() + 1)}/${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
      }
      return datetimeLocal.replace(/-/g, '/').replace('T', ' ');
    },
    nowForInput() {
      const now = new Date();
      const offsetMs = now.getTimezoneOffset() * 60000;
      return new Date(now.getTime() - offsetMs).toISOString().slice(0, 16);
    },
    refreshCurrentDateTime() {
      this.currentDateTime = this.nowForInput();
      if (!this.pointageIn) this.pointageIn = this.currentDateTime;
      if (!this.pointageOut) this.pointageOut = this.currentDateTime;
      if (!this.masspointageIn) this.masspointageIn = this.currentDateTime;
      if (!this.masspointageOut) this.masspointageOut = this.currentDateTime;
      if (!this.absent) this.absent = this.getToday();
    },
    resetPointageDateFields() {
      const now = this.nowForInput();
      this.currentDateTime = now;
      this.pointageIn = now;
      this.pointageOut = now;
      this.masspointageIn = now;
      this.masspointageOut = now;
      this.absent = this.getToday();
    },
    async addAvance(staffId) {
      try {
        const response = await fetch('/api-pointage/addavance', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ staff_id: parseInt(staffId), avance: this.avance, avanceDate: this.currentDateTime })
        });
        if (!response.ok) throw new Error('Erreur');
        alert('Avance ajoutée!');
      } catch (err) { alert('Erreur: ' + err.message); }
      this.avance = null;
    },
    async addPrime(staffId) {
      try {
        const response = await fetch('/api-pointage/addprime', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ staff_id: parseInt(staffId), prime: this.prime, primeDate: this.currentDateTime })
        });
        if (!response.ok) throw new Error('Erreur');
        alert('Prime ajoutée!');
      } catch (err) { alert('Erreur: ' + err.message); }
      this.prime = null;
    },
    async addRetenue(staffId) {
      try {
        const response = await fetch('/api-pointage/addretenue', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            staff_id: parseInt(staffId),
            amount: this.retenue,
            reason: this.retenueReason || '',
            date: this.currentDateTime,
          })
        });
        if (!response.ok) throw new Error('Erreur');
        alert('Retenue ajoutée!');
      } catch (err) { alert('Erreur: ' + err.message); }
      this.retenue = null;
      this.retenueReason = '';
    },
    async addRemarque(staffId) {
      try {
        const response = await fetch('/api-pointage/addremarque', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ staff_id: parseInt(staffId), remarque: this.remarque })
        });
        if (!response.ok) throw new Error('Erreur');
        alert('Remarque ajoutée!');
      } catch (err) { alert('Erreur: ' + err.message); }
      this.remarque = null;
    },
    async pointage(staffId, type) {
      try {
        const t = type === 'in' ? this.pointageIn : this.pointageOut;
        const response = await fetch('/api-pointage/pointage', {
          method: 'POST', 
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ type, clock: this.formatForServer(t), staff_id: staffId })
        });
        if (!response.ok) {
          const err = await response.json().catch(() => ({ error: 'Erreur pointage' }));
          throw new Error(err.error || 'Erreur pointage');
        }
        alert('Pointage enregistré!');
        this.resetPointageDateFields();
      } catch (err) { alert('Erreur: ' + (err.message || err)); }
    },
    async cancelOpenPointage(staff) {
      if (!staff?.Id) return;
      const fullName = `${staff.First_name || ''} ${staff.Last_name || ''}`.trim();
      if (!confirm(`Annuler l'entrée en cours de ${fullName} ?`)) return;
      try {
        const response = await fetch('/api-pointage/cancel-open-pointage', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ staff_id: staff.Id }),
        });
        if (!response.ok) {
          const err = await response.json().catch(() => ({ error: 'Erreur' }));
          throw new Error(err.error || 'Erreur');
        }
        alert("Entrée en cours annulée.");
        this.closeActions();
        if (this.selected) await this.fetchData(this.selected);
      } catch (err) {
        alert('Erreur: ' + err.message);
      }
    },
    openActions(staff) {
      this.activeActionStaff = staff;
    },
    closeActions() {
      this.activeActionStaff = null;
    },
    handleItemClick(staff) {
      this.showEditForm = false; this.selectedStaff = staff;
    },
    async fetchData(val) {
      if (!val) return;
      this.error = null;
      this.data = [];
      this.databackup = [];
      this.loading = true;
      this.currentPage = 1;
      this.hasMore = true;
      this.lastPost = val;
      
      try {
        const response = await fetch(`/api-pointage/staff?post=${encodeURIComponent(val)}&page=1&limit=${this.limit}`);
        if (!response.ok) throw new Error('Erreur');
        
        // Read pagination headers
        this.totalCount = parseInt(response.headers.get('X-Total-Count') || '0');
        
        const result = await response.json();
        this.data = Array.isArray(result) ? result : [];
        this.databackup = [...this.data];
        
        // Check if there are more pages
        this.hasMore = (this.currentPage * this.limit) < this.totalCount;
      } catch (err) { 
        this.error = 'Impossible de charger les employés'; 
        this.data = []; 
      }
      finally { 
        this.loading = false; 
      }
    },
    
    async loadMore() {
      if (this.loading || !this.hasMore || !this.lastPost) return;
      
      this.loading = true;
      this.currentPage += 1;
      
      try {
        const response = await fetch(`/api-pointage/staff?post=${encodeURIComponent(this.lastPost)}&page=${this.currentPage}&limit=${this.limit}`);
        if (!response.ok) throw new Error('Erreur');
        
        const result = await response.json();
        const newStaff = Array.isArray(result) ? result : [];
        
        // Append to existing data
        this.data.push(...newStaff);
        this.databackup = [...this.data];
        
        // Check if there are more pages
        this.hasMore = (this.currentPage * this.limit) < this.totalCount;
      } catch (err) {
        console.error('Error loading more staff:', err);
      } finally {
        this.loading = false;
      }
    },
    handleStaffCreated() { this.showForm = false; this.selectedStaff = null; this.showEditForm = false; if (this.selected) this.fetchData(this.selected); },
    async deletStaf(staff) {
      const fullName = `${staff.First_name} ${staff.Last_name || ''}`.trim();
      const warning = `Suppression définitive de ${fullName}\n\nAvant de continuer, supprimez d'abord l'empreinte / l'ID ${staff.Id} de la machine de pointage.\n\nAprès cette confirmation, l'employé et ses données seront supprimés définitivement.`;
      if (!confirm(warning)) {
        return;
      }
      const typedId = prompt(`Tapez l'ID ${staff.Id} pour confirmer que vous avez supprimé cet ID de la machine.`);
      if (typedId !== String(staff.Id)) {
        alert('Suppression annulée: ID incorrect.');
        return;
      }
      try {
        const response = await fetch(`/api-pointage/deletstaff?staff_id=${encodeURIComponent(staff.Id)}`);
        if (!response.ok) {
          const err = await response.json().catch(() => ({ error: 'Erreur' }));
          throw new Error(err.error || 'Erreur');
        }
        alert('Employé supprimé définitivement.');
        this.selectedStaff = null;
        this.fetchData(this.selected);
      } catch (err) {
        alert('Erreur: ' + err.message);
      }
    },
    openDossier(staffId) {
      this.selectedStaff = null;
      this.$router.push({ path: '/dossiers', query: { id: staffId } });
    },
    async masspointage(staffIds, type) {
      const t = type === 'in' ? this.masspointageIn : this.masspointageOut;
      const staffmass = staffIds.map(s => s.Id);
      try {
        const response = await fetch('/api-pointage/masspointage', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ type, clock: this.formatForServer(t), staffs: staffmass })
        });
        if (!response.ok) {
          const err = await response.json().catch(() => ({ error: 'Erreur' }));
          throw new Error(err.error || 'Erreur');
        }
        alert('Pointage en masse enregistré!');
        this.resetPointageDateFields();
      } catch (err) { alert('Erreur: ' + err.message); }
    },
    convertclock(input) {
      if (!input) return '';
      const [date, time] = input.split('T');
      if (!date || !time) return input;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year} ${time.slice(0, 5)}`;
    },
    formatDate(input) {
      if (!input) return '';
      const d = input.substring(0, 10);
      const [year, month, day] = d.split('-');
      if (!year || !month || !day) return input;
      return `${day}/${month}/${year}`;
    },
    getToday() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  },
};
</script>

<style scoped>
.mainbar {
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: relative;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.page-title-wrap {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
  justify-content: center;
}

.title-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.dept-chip {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dept-chip svg {
  width: 20px;
  height: 20px;
}

.page-header h1 {
  font-size: 23px;
  margin-bottom: 3px;
}

.header-actions-inline {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.header-actions-inline .btn svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.page-subtitle {
  font-size: 13px;
  color: var(--gray-500);
}

/* Toolbar */
.toolbar {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: var(--shadow-sm);
}

.search-wrap {
  position: relative;
  flex: 1;
}

.search-icon-svg {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: var(--gray-400);
  pointer-events: none;
}

.search-input {
  padding-left: 38px !important;
  background: var(--gray-50) !important;
  border-color: var(--border) !important;
}

.search-input:focus {
  background: var(--white) !important;
}

/* Bulk */
.bulk-bar {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  flex-wrap: wrap;
}

.bulk-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.bulk-count {
  font-size: 13px;
  font-weight: 600;
  color: var(--primary);
  white-space: nowrap;
}

.bulk-controls {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.bulk-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bulk-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--gray-500);
  white-space: nowrap;
}

/* Checkbox */
.checkbox-wrap {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.checkbox-wrap input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.checkmark {
  width: 18px;
  height: 18px;
  border: 2px solid var(--border-2);
  border-radius: 5px;
  background: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition);
}

.checkbox-wrap input:checked~.checkmark {
  background: var(--primary);
  border-color: var(--primary);
}

.checkbox-wrap input:checked~.checkmark::after {
  content: '';
  width: 5px;
  height: 9px;
  border: 2px solid #fff;
  border-top: none;
  border-left: none;
  transform: rotate(45deg) translateY(-1px);
  display: block;
}

/* States */
.state-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 26vh;
  gap: 12px;
  color: var(--gray-400);
  font-size: 15px;
}

.state-error {
  color: var(--danger);
}

.state-error svg {
  width: 40px;
  height: 40px;
}

.state-icon {
  width: 48px;
  height: 48px;
  background: var(--gray-100);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray-400);
}

.state-icon svg {
  width: 28px;
  height: 28px;
}

.spinner-ring {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Staff Grid */
.staff-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px;
}

.staff-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: var(--shadow-sm);
  transition: all var(--transition);
  position: relative;
}

.staff-card:hover {
  border-color: var(--border-2);
  box-shadow: var(--shadow-md);
}

.stopped-card {
  border-color: rgba(220, 38, 38, 0.35);
  background: rgba(254, 242, 242, 0.65);
}

.selected-card {
  border-color: var(--primary);
  background: var(--primary-glow);
}

.card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
}

.card-check {
  margin-top: 2px;
}

.staff-avatar {
  width: 76px;
  height: 76px;
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
  border: 2px solid var(--border);
  transition: all var(--transition);
  display: block;
  margin: 0 auto;
}

.staff-avatar:hover { border-color: var(--primary); }

.staff-status-dot {
  width: 10px;
  height: 10px;
  background: var(--success);
  border-radius: 50%;
  border: 2px solid var(--white);
  position: absolute;
  right: 4px;
  bottom: 0;
}

.status-stopped-dot {
  background: var(--danger);
}

.card-info {
  text-align: center;
  cursor: pointer;
}

.card-info h3 {
  font-size: 14px;
  color: var(--gray-900);
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.staff-post-badge {
  display: inline-flex;
  padding: 3px 10px;
  background: var(--primary-glow);
  color: var(--primary);
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
}

.stopped-badge {
  display: inline-flex;
  margin-left: 6px;
  padding: 3px 10px;
  background: rgba(239, 68, 68, 0.14);
  color: #dc2626;
  border-radius: var(--radius-full);
  font-size: 11.5px;
  font-weight: 700;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.card-footer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-footer .btn-phone {
  flex: 1;
  justify-content: center;
}

.toggle-more-btn {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border: 1.5px solid var(--border);
  background: var(--gray-50);
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray-500);
  transition: all var(--transition);
}

.toggle-more-btn svg {
  width: 15px;
  height: 15px;
}

.toggle-more-btn:hover {
  background: var(--primary-glow);
  color: var(--primary);
  border-color: var(--primary);
}

.action-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.action-item {
  background: var(--gray-50);
  border-radius: var(--radius-sm);
  padding: 9px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.action-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 700;
  color: var(--gray-500);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.action-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.dot-green {
  background: var(--success);
}

.dot-blue {
  background: var(--info);
}

.dot-red {
  background: var(--danger);
}

.dot-amber {
  background: var(--warning);
}

.dot-purple {
  background: #7c3aed;
}

.dot-orange {
  background: #f97316;
}

.dot-rose {
  background: #e11d48;
}

.dot-gray {
  background: var(--gray-500);
}

.action-help {
  margin: 0;
  color: var(--gray-500);
  font-size: 12px;
  line-height: 1.35;
}

.dot-teal {
  background: #14b8a6;
}

/* Action Modal */
.action-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1550;
  background: rgba(10, 18, 40, 0.42);
  backdrop-filter: blur(2px);
}

.action-modal {
  position: fixed;
  top: calc(var(--header-height) + 22px);
  left: 50%;
  z-index: 1560;
  width: min(920px, calc(100vw - 48px));
  max-height: calc(100vh - var(--header-height) - 44px);
  overflow-y: auto;
  transform: translateX(-50%);
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-lg);
}

.action-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 15px 18px;
  border-bottom: 1px solid var(--border);
}

.action-modal-head h2 {
  margin: 2px 0 6px;
  font-size: 18px;
}

.action-modal-kicker {
  margin: 0;
  font-size: 11px;
  font-weight: 800;
  color: var(--primary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.action-modal-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(190px, 1fr));
  gap: 14px;
  padding: 20px;
}

.action-modal-grid .action-item {
  min-height: 132px;
  border: 1px solid var(--border);
  background: var(--white);
  border-radius: var(--radius-md);
  padding: 14px;
  box-shadow: var(--shadow-sm);
}

.action-modal-grid .form-input,
.action-modal-grid .btn {
  width: 100%;
}

.action-modal-grid .btn {
  margin-top: auto;
}

.action-in {
  border-top: 3px solid var(--success) !important;
}

.action-out {
  border-top: 3px solid var(--info) !important;
}

.action-absent,
.action-retenue {
  border-top: 3px solid var(--danger) !important;
}

.action-avance {
  border-top: 3px solid #f59e0b !important;
}

.action-prime {
  border-top: 3px solid #f97316 !important;
}

.action-remarque {
  border-top: 3px solid #7c3aed !important;
}

.btn-prime {
  background: #f97316;
  color: #fff;
}

.btn-prime:hover:not(:disabled) {
  background: #ea580c;
}

.btn-note {
  background: #7c3aed;
  color: #fff;
}

.btn-note:hover:not(:disabled) {
  background: #6d28d9;
}

/* Detail Panel */
.detail-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 18, 40, 0.4);
  z-index: 1500;
  backdrop-filter: blur(2px);
}

.detail-panel {
  position: fixed;
  top: calc(var(--header-height) + 24px);
  left: 50%;
  width: min(980px, calc(100vw - 48px));
  height: calc(100vh - var(--header-height) - 48px);
  z-index: 1600;
  background: var(--white);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-xl);
  overflow: hidden;
  border-radius: 16px;
  transform: translateX(-50%);
}

.detail-panel-inner {
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  align-content: start;
  gap: 18px;
  position: relative;
}

.detail-close {
  position: absolute;
  top: 16px;
  right: 16px;
}

.detail-hero {
  text-align: center;
  padding: 24px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--gray-50);
}

.detail-avatar {
  width: 96px;
  height: 96px;
  border-radius: 20px;
  object-fit: cover;
  margin: 0 auto 14px;
  border: 3px solid var(--border);
  display: block;
}

.detail-hero h2 {
  font-size: 20px;
  margin-bottom: 8px;
}

/* Info List */
.detail-info {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  border-bottom: 1px solid var(--border);
  border-right: 1px solid var(--border);
  transition: background var(--transition);
}

.info-item:nth-child(2n),
.info-item:last-child {
  border-right: none;
}

.info-item:last-child,
.info-item:nth-last-child(2):nth-child(odd) {
  border-bottom: none;
}

.info-item:hover {
  background: var(--gray-50);
}

.info-icon {
  width: 32px;
  height: 32px;
  background: var(--primary-glow);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary);
  flex-shrink: 0;
}

.info-icon svg {
  width: 14px;
  height: 14px;
}

.status-info-icon {
  background: var(--success-bg);
  color: var(--success);
}

.status-info-stopped {
  background: rgba(239, 68, 68, 0.14);
  color: var(--danger);
}

.info-label {
  font-size: 11px;
  font-weight: 700;
  color: var(--gray-400);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.info-value {
  font-size: 13.5px;
  font-weight: 500;
  color: var(--gray-800);
  margin-top: 1px;
}

.salary-value {
  color: var(--success);
  font-weight: 700;
}

.resignation-value {
  color: var(--danger);
  font-weight: 600;
}

.detail-actions {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-top: 1px solid #f1f1f1;
  background: #fafafa;
}

/* PHONE BUTTON */
.btn-phone {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #0ba71f, #1bc732);
  color: white;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);
}

.btn-phone svg {
  width: 16px;
  height: 16px;
}

.btn-phone:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.3);
}

/* TOGGLE BUTTON */
.toggle-more-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s ease;
}

.toggle-more-btn svg {
  width: 18px;
  height: 18px;
  color: #6b7280;
}

.toggle-more-btn:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
  transform: translateY(-2px);
}

.danger {
  padding: 4px 8px;
  font-size: 13px;
}

@media (max-width: 768px) {
  .staff-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .action-modal-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .detail-panel {
    left: 0;
    transform: none;
    width: 100%;
  }

  .detail-panel-inner {
    grid-template-columns: 1fr;
  }

  .detail-actions {
    flex-direction: column;
  }

  .detail-info {
    grid-template-columns: 1fr;
  }

  .info-item,
  .info-item:nth-child(2n) {
    border-right: none;
  }
}

@media (max-width: 480px) {
  .staff-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .staff-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px 14px 12px;
    border-radius: 8px;
  }

  .card-top {
    justify-content: center;
  }

  .staff-avatar {
    width: 112px;
    height: 112px;
    border-radius: 12px;
  }

  .staff-status-dot {
    right: calc(50% - 58px);
    bottom: 4px;
  }

  .card-info {
    text-align: center;
  }

  .card-info h3 {
    white-space: normal;
    margin-bottom: 4px;
  }

  .card-footer {
    padding: 0;
    background: transparent;
    border-top: none;
  }

  .action-item .btn,
  .action-item a,
  .action-item input {
    width: 100%;
  }

  .page-header {
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding-left: 0;
  }

  .page-title-wrap {
    width: 100%;
    justify-content: center;
  }

  .header-actions-inline {
    width: auto;
    justify-content: center;
  }

  .header-actions-inline .btn {
    width: auto;
    min-height: 42px;
  }

  .detail-panel {
    top: auto;
    bottom: 0;
    width: 100%;
    height: 88vh;
    border-radius: 16px 16px 0 0;
    border-left: none;
  }

  .detail-panel-inner {
    padding: 16px;
  }

  .detail-actions .btn {
    min-height: 46px;
  }

  .action-modal {
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    max-height: 88vh;
    transform: none;
    border-radius: 16px 16px 0 0;
  }

  .action-modal-head {
    padding: 14px 16px;
  }

  .action-modal-grid {
    grid-template-columns: 1fr;
    padding: 14px;
  }
}
</style>
